import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { CountrySelectionService } from '../services/country-selection.service';

export const countryGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const countrySelectionService = inject(CountrySelectionService);
  //BORRAR CUANDO SE EMPIECE A TENER MAS PAISES DRINKHOPPING
  localStorage.setItem('selectedCountryIso', 'PA')
  const iso = localStorage.getItem('selectedCountryIso');

  if (!iso) {
    router.navigate(['/select-country']);
    return false;
  }

  // Si los países no están cargados, permitir navegar temporalmente
  if (!countrySelectionService['countriesLoaded']) {
    return true;
  }

  if (countrySelectionService.isValidCountry(iso)) {
    return true;
  } else {
    console.warn('ISO de país inválido detectado:', iso);
    // No eliminamos el país guardado, solo redirigimos a select-country
    router.navigate(['/select-country']);
    return false;
  }
};